import React from "react";
import {
    RazonFinancieraSubItem4_1,
} from "./RazonFinancieraSubItem";
import { GetKey } from "../../Actions/GetContainer";

export const RotacionCXCItem = ({ data, sucursales, sucursalesSeleccionadas, ejercicioSelect, periodoSelect, optima = false }) => {


    const rotacionCXC = data?.rotacioncxc?.cxc ?? 0
    const guiaCXC = data?.rotacioncxc?.guia_cxc ?? 0

    const GetIndicador = (valor, minino, medio) => {
        if (valor <= minino) return "flag-red";
        else if (valor <= medio) return "flag-yellow";
        else return "flag-green";
    };
    const getMedida = (indicador) => {
        if (indicador === "%") return "porcentaje";
        if (indicador === "x") return "numero-vueltas";
    };

    const convertGuiaNumero = (guia) => {
        if (!guia) return 0;
        const value = guia.replace(/[^\d\.x]/g, '');
        if (value.includes('x')) {
            return parseFloat(value.replace('x', ''));
        } else {
            return parseFloat(value);
        }
    };

    // console.log(rotacionActivosIndicador)
    // console.log (getMedida(rotacionActivosIndicador))

    return (
        <>
            <div className="dashboard-financiero-razones-financieras-proyecciones2">
                <RazonFinancieraSubItem4_1
                    titulo={optima ? "Rotación CXC Optima" : "Rotación CXC"}
                    valor={rotacionCXC}
                    guia={guiaCXC}
                    medida={"numero-vueltas"}
                    modal={optima ? "RotacionCXCOptimaMainScreen" : "RotacionCXCMainScreen"}
                    sucursales={sucursales}
                    sucursalesSeleccionadas={sucursalesSeleccionadas}
                    ejercicioSelect={ejercicioSelect}
                    periodoSelect={periodoSelect}

                />
            </div>
        </>
    );
};
